import { Box } from '@usap/uicomponents'
import React from 'react'
import { ProceedToCheckoutSection } from './css/proceed-to-checkout.css'
import { ProceedToCheckoutButton } from './ProceedToCheckoutWmo.css'

type ProceedToCheckoutWmoProps = {
  isProcessing: boolean
  handleAction: () => void
  buttonLabel: React.ReactNode,
  buttonElementId: string
  buttonWrapperId: string
}

const ProceedToCheckoutWmo: React.FC<ProceedToCheckoutWmoProps> = ({
  isProcessing,
  handleAction,
  buttonLabel,
  buttonElementId,
  buttonWrapperId,
}) => (
  <ProceedToCheckoutSection id="cart__proceed-to-checkout--section">
    <Box className={buttonWrapperId}>
      <ProceedToCheckoutButton
        id={buttonElementId}
        onClick={handleAction}
        disabled={isProcessing}
      >
        {buttonLabel}
      </ProceedToCheckoutButton>
    </Box>
  </ProceedToCheckoutSection>
)

export default ProceedToCheckoutWmo
